import { BROADCAST_STOP_PRESENTER_SCREEN_SHARE } from 'actions/Types';
import { SCREEN_SHARE_STOP } from 'constants/SocketEmitters';
import { decreaseScreenShare } from '@shoflo/studio-redux/actions';
export default source => {
  return (dispatch, getState, socket) => {
    const { broadcast } = getState();
    const action = {
      type: BROADCAST_STOP_PRESENTER_SCREEN_SHARE,
      request: async () => {
        const payload = {
          attendeeId: source.value.replace('#content', ''),
          broadcastId: broadcast._id
        };
        socket.emit(SCREEN_SHARE_STOP, payload);
        dispatch(decreaseScreenShare());
        return Object.create(null);
      }
    };
    dispatch(action);
  };
};
